<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Purchased: His Perfect Wife</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="frontMatterPage" id="fm02"><div class="chapterHead"><h2 class="chapterTitle0"> </h2></div><div class="chapterBody"><p class="paraCenter"><span><em class="italic"><span>Legally wed,<br/>
but he’s never said,<br/>
“I love you.”</span></em></span></p><p class="paraCenter"><span><em class="italic"><span>They’re…</span></em></span></p><p class="CenterImage"><span><img alt="image" src="Images/sub.jpg"/></span></p><p class="paraCenter"><span><em class="italic"><span>The series where marriages are made<br/>
in haste…and love comes later.</span></em></span></p><br/><p class="paraCenter"><span><em class="italic"><span>Look out for more WEDLOCKED!<br/>
wedding stories available only from<br/>
Harlequin Presents</span></em><sup>®</sup><em class="italic"><span>.</span></em></span></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// purchasedhisperfectwife_fm02.vue?6d1e324c